export const ALLOWED_KEYS = [
  'Backspace', 'Delete', 'Tab',
  'Escape', 'Enter', 'ArrowLeft',
  'ArrowRight', 'ArrowUp', 'ArrowDown',
  'Home', 'End'
];

export const ALLOWED_CTRL_CODES = [
  'KeyA', 'KeyC', 'KeyV', 'KeyX', 'KeyZ']
;
